import AsyncStorage from "@react-native-async-storage/async-storage";
import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from "react";
import { ScrollView, Text, View, TouchableOpacity, TextInput } from "react-native";
import HeaderDefault from "../../components/HeaderDefault";
import activesService from "../../services/activesService";
import styles from "./styles";
import balanceService from '../../services/balanceService';
import NumberInput from '../../components/NumberInput';
import { isConstructorDeclaration } from "typescript";
import { maxDecimals } from "../../utils/formatNumber";

const Transfer = ({ navigation }) => {
    const defaultItem = {
        label: 'GPX/BRL',
        value: -1,
        // icon: () => (
        //     <Image source={require('../../../assets/imgs/gpx.png')} style={styles.iconSelect} />
        // ),
    };

    const [items, setItems] = useState([defaultItem]);
    const [balance, setBalance] = useState("");

    const [amount, setAmount] = useState(0);
    const [selectedActive, setSelectedActive] = useState(null);
    const [selectedActiveObj, setSelectedActiveObj] = useState(null);

    const [price, setPrice] = useState(0.0);
    const [authToken, setAuthToken] = useState(null);

    const [actives, setActives] = useState([]);
    const [open, setOpen] = useState(false);

    const [minTransfer, setMinTransfer] = useState(1);
    
    const [decimals, setDecimals] = useState(0);

    const [amountToken, setAmountToken] = useState(0);

    useEffect(() => {
        let itemsAr = [defaultItem];
        actives.map((el) => {
            itemsAr.push({
                label: el.name_token,
                value: el.id,
                // icon: () => (
                //     <Image
                //         source={{
                //             uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${el.path}`,
                //         }}
                //         style={styles.iconSelect}
                //     />
                // ),
            });
        });
        setItems(itemsAr);
    }, [actives]);

    useEffect(() => {
        // console.log('items');
        // console.log(items);
        loadTokenAndRequest();
    }, []);

    useEffect(() => {
        if (parseInt(selectedActive + '') === -1) {
            setSelectedActiveObj({
                id: -1,
                name_token: 'GPX/BRL',
                single_value: 1,
                amount_token: '-'
            })
            loadBalanceGPX();
        } else {
            actives.map((el) => {
                if (el.id + '' === selectedActive + '') {
                    setSelectedActiveObj(el);
                    if (el.single_value) {
                        setPrice(parseFloat(el.single_value));
                    }
                    if(el.name_token) {
                        if(['BTC', 'ETH', 'ADA'].indexOf(el.name_token) !== -1)
                            setDecimals(8);
                        if(!el.cryptoactive && ['BTC', 'ETH', 'ADA'].indexOf(el.name_token) === -1) {
                            loadAmountToken();
                        }else{
                            setAmountToken(0);
                        }                  
                    }
                }
            });
            loadBalance();
        }
    }, [selectedActive]);

    useEffect(() => {
        calcMinTransfer();
    }, [selectedActiveObj]);

    useEffect(() => {
        if (authToken) {
            loadActivesWithBalance();
        }
    }, [authToken]);

    const loadAmountToken = async () => {
        if(authToken) {
            activesService.getById(authToken, selectedActive).then((response) => {
                if(response.data?.count) {
                    setAmountToken(response.data?.count);
                }
            });
        }
    }

    const loadTokenAndRequest = async () => {
        const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
        setAuthToken(authTokenStorage);
    };

    const loadActivesWithBalance = () => {
        activesService.getActivesWhereUserHasBalance(authToken).then((response) => {
            if (response.data.length > 0) {
                setActives(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const loadBalance = () => {
        if (authToken) {
            balanceService.getBalanceOfToken(authToken, selectedActive).then((response) => {
                setBalance(response?.data?.saldo + '');
            }).catch((error) => {
            });
        }
    }

    const loadBalanceGPX = () => {
        if (authToken) {
            balanceService.getBalanceOfGpx(authToken).then((res) => {
                if (res.data.balance[0]?.available_balance) {
                    setBalance(res.data.balance[0].available_balance);
                } else {
                    setBalance(res.data.balance[0].saldo);
                }
            }).catch((error) => {
            });
        }
    }

    const calcMinTransfer = () => {
        console.log('calc min');
        console.log(selectedActiveObj?.name_token);
        if (selectedActiveObj) {
            if (selectedActiveObj.name_token === 'BTC') {
                setMinTransfer(0.0008);
            } else if (selectedActiveObj.name_token === 'ADA') {
                setMinTransfer(10);
            } else if (selectedActiveObj.name_token === 'ETH') {
                setMinTransfer(0.016);
            } else if (selectedActiveObj.name_token === 'GPX/BRL') {
                setMinTransfer(10);
            } else {
                setMinTransfer(1);
            }
        }
    }

    return (
        <>
            <HeaderDefault title={"Transferir"} />

            <ScrollView style={styles.content}>
                <Text style={styles.title}>Desejo transferir:</Text>

                <View style={styles.contentSelect}>

                    <select
                        value={selectedActive}
                        onChange={(e) => { setSelectedActive(e.target.value) }}
                        style={{
                            marginTop: 10, maxWidth: 350, fontSize: 16, background: '#FFFFFF', border: '2px solid #DDD', borderRadius: 5, padding: 10, alignSelf: 'center', color: '#444444'
                        }}
                    >
                        <option value="0">Selecione um ativo</option>
                        {
                            items.map((el, index) =>
                                <option key={index} value={el.value}>{el.label}</option>
                            )
                        }
                    </select>
                </View>
                {selectedActive ? (
                    <>
                        <View style={{ flexDirection: "row", display: "flex" }}>
                            <Text
                                style={{ ...styles.textAmount, flex: 0.5, fontWeight: "400" }}
                            >
                                Preço
                            </Text>
                            <Text
                                style={{ ...styles.textAmount, flex: 0.5, textAlign: "right" }}
                            >
                                {selectedActiveObj && selectedActiveObj.single_value} GPX
                            </Text>
                        </View>
                        <View style={{ textAlign: "right", color: "#999999" }}>
                            <Text style={{ textAlign: "right", color: "#999999" }}>
                                {selectedActiveObj && selectedActiveObj.single_value} BRL
                            </Text>
                        </View>

                        <View
                            style={{ flexDirection: "row", marginTop: 15, marginBottom: 15 }}
                        >
                            <View style={{ flex: 0.5 }}>
                                {
                                    selectedActive !== -1 &&
                                    <Text style={{ fontWeight: "700", fontSize: 16 }}>
                                        {
                                            !selectedActiveObj?.cryptoactive && parseInt(amountToken) > 0 &&
                                            <Text style={{ fontWeight: '700', fontSize: 16 }}>Quantidade disponível{"\n"}<Text style={{ fontWeight: '400', color: '#656565' }}>{amountToken} {selectedActiveObj && selectedActiveObj.name_token}</Text></Text>
                                        }
                                    </Text>
                                }
                            </View>
                            <View style={{ flex: 0.5 }}>
                                <Text
                                    style={{
                                        textAlign: "right",
                                        fontWeight: "700",
                                        fontSize: 16,
                                    }}
                                >
                                    Meu saldo{"\n"}
                                    <Text style={{ fontWeight: "400", color: "#656565" }}>
                                        {selectedActiveObj?.cryptoactive ? maxDecimals(balance, 8) : balance
                    }{" "}
                                        {selectedActiveObj && selectedActiveObj.name_token}
                                    </Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.contentPurchase}>
                            <Text style={styles.titlePurchase}>
                                Quantas unidades deseja transferir?
                            </Text>
                            <View style={styles.contentPurchaseAmount}>
                                <NumberInput
                                    minValue={0}
                                    value={amount}
                                    maxDecimalsParam={decimals}
                                    onChange={value => setAmount(value)} />
                            </View>
                        </View>
                    </>
                ) : (
                    <>
                        <View style={{ padding: 15, marginTop: 50, marginBottom: 50 }}>
                            <Text style={{ textAlign: "center" }}>
                                Antes de continuar, selecione o que deseja transferir.
                            </Text>
                        </View>
                    </>
                )}
            </ScrollView>

            <View style={styles.contentBtn}>

                {selectedActive ? (
                    amount && parseFloat(amount + '') >= minTransfer ? (
                        parseFloat(amount + '') > parseFloat(balance) ? (
                            <TouchableOpacity onPress={() => navigation.navigate("DepositMethod")}>
                                <LinearGradient
                                    start={{ x: -1, y: 0 }}
                                    end={{ x: 1, y: 0 }}
                                    colors={["#16195B", "#1FBFB5"]}
                                    style={styles.btn}
                                >
                                    <Text style={styles.textBtn}>SALDO INSUFICIENTE</Text>
                                </LinearGradient>
                            </TouchableOpacity>

                        ) : (
                            <TouchableOpacity
                                disabled={amount <= 0 ? true : false}
                                onPress={() =>
                                    navigation.navigate({
                                        name: "TransferFindUser",
                                        params: { token: selectedActive, qtd: amount },
                                    })
                                }
                            >
                                <LinearGradient
                                    start={{ x: -1, y: 0 }}
                                    end={{ x: 1, y: 0 }}
                                    colors={["#16195B", "#1FBFB5"]}
                                    style={styles.btn}
                                >
                                    <Text style={styles.textBtn}>CONTINUAR</Text>
                                </LinearGradient>
                            </TouchableOpacity>

                        )
                    ) : (
                        <TouchableOpacity disabled={true}>
                            <LinearGradient
                                start={{ x: -1, y: 0 }}
                                end={{ x: 1, y: 0 }}
                                colors={["#16195B", "#1FBFB5"]}
                                style={styles.btn}
                            >
                                <Text style={styles.textBtn}>MÍNIMO DE {minTransfer} {selectedActiveObj?.name_token}</Text>
                            </LinearGradient>
                        </TouchableOpacity>
                    )
                ) : (
                    <TouchableOpacity disabled={true}>
                        <LinearGradient
                            start={{ x: -1, y: 0 }}
                            end={{ x: 1, y: 0 }}
                            colors={["#16195B", "#1FBFB5"]}
                            style={styles.btn}
                        >
                            <Text style={styles.textBtn}>SELECIONE UM ATIVO</Text>
                        </LinearGradient>
                    </TouchableOpacity>
                )}
            </View>        </>
    )
}

export default Transfer;
